<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="none">
      <path fill="#FFF" d="M16 16H0V0h16v8z" />
      <path
        d="M16 16v-2.534h-1.93l-.995-1.098-.998 1.098H5.712v-5.12H3.658l2.55-5.77h2.458l.876 1.974V2.576h3.04l.528 1.488.532-1.488H16V0H0v16h16zm-1.606-3.178H16l-2.125-2.252L16 8.342h-1.58l-1.313 1.434-1.299-1.434h-1.606l2.112 2.24-2.112 2.24h1.561l1.319-1.446 1.312 1.446zm.377-2.25L16 11.883V9.277l-1.229 1.296zM7.613 11.79v-.698h2.528V10.08H7.613v-.698h2.592V8.346H6.394v4.476h3.81v-1.036H7.614v.003zm7.177-4.093H16V3.219h-1.882l-1.004 2.79-.999-2.79h-1.913v4.477h1.21V4.563l1.151 3.133h1.075l1.152-3.142v3.142zm-5.961 0h1.376L8.227 3.219H6.656L4.678 7.696h1.344l.372-.896h2.06l.375.896zm-.8-1.9H6.813L7.42 4.33l.608 1.465z"
        fill="#006FCF"
      />
    </g>
  </svg>
</template>
